import { useRef, useEffect, useState } from 'react'

export const BannerActivist = () => {
  
  const contentRef = useRef(null);
  const [isOpen, setIsOpen] = useState(true);
  const [isPaused, setIsPaused] = useState(false);
  const positionRef = useRef(0);

  useEffect(() => {
    const content = contentRef.current;
    if (!isOpen || !content) return;

    const speed = 1;
    let animationFrame;

    const animate = () => {
        if (!isPaused) {
          positionRef.current -= speed;
          if (positionRef.current <= -content.offsetWidth) {
            positionRef.current = window.innerWidth;
          }
          content.style.transform = `translateX(${positionRef.current}px)`;
        }
        animationFrame = requestAnimationFrame(animate);
    };
    animationFrame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationFrame);
  }, [isOpen, isPaused]);
    

  return (
    <>
    {isOpen && (
    <div
      className='banner-activist'
      style={{
        position: 'fixed',
        top: '63px',
        left: 0,
        zIndex: 1100,
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        minHeight: '64px',
        overflow: 'hidden',
        padding: '10px 64px 10px 16px',
        boxSizing: 'border-box',
        border: 'none',
        borderBottom: '1px solid rgba(255, 255, 255, 0.22)',
        borderRadius: 0,
        background: 'linear-gradient(100deg, rgba(8, 12, 24, 0.82), rgba(39, 15, 45, 0.68), rgba(8, 12, 24, 0.82))',
        backdropFilter: 'blur(20px) saturate(160%)',
        WebkitBackdropFilter: 'blur(20px) saturate(160%)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.18)',
      }}
    >
        <button
          type="button"
          onClick={() => setIsOpen(false)}
          aria-label="Cerrar banner"
          style={{
            position: 'absolute',
            zIndex: 2,
            top: '50%',
            right: '16px',
            transform: 'translateY(-50%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '40px',
            height: '40px',
            padding: 0,
            border: '1px solid rgba(255, 255, 255, 0.36)',
            borderRadius: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.08)',
            color: '#fff',
            fontSize: '26px',
            lineHeight: 1,
            cursor: 'pointer',
          }}
        >
          &times;
        </button>
        <div
            style={{ width: '100%', overflow: 'hidden' }}
            onMouseEnter={() => setIsPaused(true)} 
            onMouseLeave={() => setIsPaused(false)} 
        >    
            <div
                ref={contentRef}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 'clamp(12px, 2vw, 28px)',
                  width: 'max-content',
                  minHeight: '42px',
                  whiteSpace: 'nowrap',
                }}
            >
                <img
                    src="/mainimg/newpalestine1.webp"
                    alt="Activist Banner"
                    width="48"
                    height="48"
                    className="activist-image"
                    style={{ width: 'clamp(40px, 5vw, 48px)', height: 'clamp(40px, 5vw, 48px)', objectFit: 'contain' }}
                />
                <a
                  href="https://english.pnn.ps/"
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: 'inherit', textDecoration: 'none' }}
                >
                  <span
                    style={{
                      color: '#fff',
                      fontFamily: '"Arial Black", Impact, system-ui, sans-serif',
                      fontSize: 'clamp(17px, 3vw, 24px)',
                      fontWeight: 900,
                      letterSpacing: '0.12em',
                      lineHeight: 1.2,
                      textTransform: 'uppercase',
                      textShadow: '0 0 18px rgba(244, 114, 182, 0.65)',
                    }}
                  >
                    Free Palestine!!
                  </span>
                </a>
                <img
                    src="/mainimg/newpalestine2.webp"
                    alt="Activist Banner"
                    width="48"
                    height="48"
                    className="activist-image"
                    style={{ width: 'clamp(40px, 5vw, 48px)', height: 'clamp(40px, 5vw, 48px)', objectFit: 'contain' }}
                />
            </div>
        </div>    
    </div>
    )}
    </>
  )
}
